import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isToolConfig = objectOf({
  tool_type: string,
  definition_id: string,
  excluded_fields: arrayOf(string),
});

export const isConversationalWorkflowStep = objectOf({
  instruction: string,
  tool_configs: arrayOf(isToolConfig),
});

export const isConversationalWorkflowChatSetting = objectOf({
  app_ids: arrayOf(string),
});

export const isConversationalWorkflowMessagingChannelSetting = objectOf({
  subscription_group_ids: arrayOf(string),
});

export const isConversationalWorkflowResultObject = objectOf({
  id: string,
  name: string,
  purpose: string,
  steps: arrayOf(isConversationalWorkflowStep),
  chat_setting: anyOf(nullOrUndefined, isConversationalWorkflowChatSetting),
  messaging_channel_setting: anyOf(nullOrUndefined, isConversationalWorkflowMessagingChannelSetting),
  created_by_email: string,
  created_at: string,
  updated_at: string,
});

export const isConversationalWorkflowResult = objectOf({
  result: isConversationalWorkflowResultObject,
});
